export const getArenaConfig = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const alternativeHeaderRequested = urlParams.get('alternativeHeader') !== null;

	const enableLogin = window.arenaParams?.enableLogin || false;
	const disableLogin = window.arenaConfig?.disableLogin ?? false;

	return {
		domainKey:                             window.arenaConfig?.domainKey || null,
		isSmartTv:                             window.$Helpers?.isSmartTV(),
		isAsport:                              window.isAsport,
		isSwissLeague:                         window.isSwissLeague || false,
		isStvFsg:                              window.isStvFsg || false,
		isSwissVolley:                         window.isSwissVolley || false,
		isSportAustria:                        window.isSportAustria || false,
		isOetv:                                window.isOetv || false,
		isSfl:                                 window.isSfl || false,
		isKrone:                               window.isKrone || false,
		isPhygital:                            window.isPhygital || false,
		isPhygitalPlus:                        window.isPhygitalPlus || false,
		isEuf:                                 window.isEuf || false,
		isSwissFutsal:                         window.isSwissFutsal || false,
		isMz:                                  window.isMz || false,
		kroneOfferUrl:                         'https://www.krone.at/sportabo',
		upcomingEventIndex:                    window.arenaConfig?.upcomingEventIndex ?? 1,
		showLeaguesAsSport:                    window.arenaConfig?.showLeaguesAsSport || false,
		showTeamsAsSport:                      window.arenaConfig?.showTeamsAsSport || false,
		enableSportsFilterInVideoCenter:       window.arenaConfig?.enableSportsFilterInVideoCenter || false,
		enableDateFilterInVideoCenter:         window.arenaConfig?.enableDateFilterInVideoCenter || false,
		enableTeamCategoryFilterInVideoCenter: window.arenaConfig?.enableTeamCategoryFilterInVideoCenter || false,
		enableTeamFilterInVideoCenter:         window.arenaConfig?.enableTeamFilterInVideoCenter || false,
		hideEventCardSportTag:                 window.arenaConfig?.hideEventCardSportTag ?? true,
		headerImageLink:                       window.arenaConfig?.headerImageLink || null,
		enableLiveheader:                      window.arenaConfig?.enableLiveheader || false,
		videoDownloadEnabled:                  window.arenaConfig?.videoDownloadEnabled || false,
		terms:                                 window.arenaConfig?.terms ?? 'asport',
		about:                                 window.arenaConfig?.about ?? null,
		headerImageUrl:                        window.arenaConfig?.headerImageUrl || null,
		footerImageUrl:                        window.arenaConfig?.footerImageUrl || null,
		socialMedia:                           window.arenaConfig?.socialMedia || [],
		cookieConsent:                         window.arenaConfig?.cookieConsent || false,
		cookieConsentRevisionNr:               window.arenaConfig?.cookieConsentRevisionNr || null,
		googleAnalyticsId:                     window.arenaConfig?.googleAnalyticsId || null,
		menuItems:                             window.arenaConfig?.menuItems || null,
		additionalMenuItems:                   window.arenaConfig?.additionalMenuItems || null,
		extraTopNavItems:                      window.arenaConfig?.extraTopNavItems || null,
		navigationSports:                      window.arenaConfig?.navigationSports || null,
		enableNoSpoilerMode:                   window.arenaConfig?.enableNoSpoilerMode || false,
		enableMomentsFeed:                     window.arenaConfig?.enableMomentsFeed || false,
		enableVideoFeed:                       window.arenaConfig?.enableVideoFeed || false,
		eventCenterEnabled:                    window.arenaParams?.eventCenterEnabled ?? false,
		eventCenterShowAllEvents:              window.arenaParams?.eventCenterShowAllEvents ?? true,
		videoCenterEnabled:                    window.arenaParams?.videoCenterEnabled ?? false,
		videoCenterLiveUpcomingEnabled:        window.arenaParams?.videoCenterLiveUpcomingEnabled ?? false,
		alternativeHeader:                     window.arenaConfig?.alternativeHeader || alternativeHeaderRequested,
		enableLogin,
		disableLogin,
		disableLoginMessage:                   window.arenaConfig?.disableLoginMessage ?? null,
		isArenaLoginUiEnabled:                 enableLogin && !disableLogin,
		enableLoginRedirect:                   window.arenaParams?.enableLoginRedirect || false,
		followingEnabled:                      window.arenaParams?.followingEnabled || false,
		type:                                  window.arenaParams?.arenaContextableType || null,
		id:                                    window.arenaParams?.arenaContextableId ?? null,
		isCustomDomain:                        window.arenaParams?.isCustomDomain || false,
		slug:                                  window.arenaParams?.contextSlug || null,
		locales:                               window.arenaParams?.locales || [],
		hideSponsorsOnRoutes:                  window.arenaParams?.hideSponsorsOnRoutes || [],
		paymentsEnabled:                       window.arenaParams?.paymentsEnabled ?? false,
		languages:                             window.arenaConfig?.languages || [],
		defaultLanguage:                       window.arenaParams?.defaultLanguage,
		currentLanguage:                       window.arenaParams?.currentLanguage,
		currentLanguageKey:                    window.locale || 'en',
		showPoweredBy:                         window.arenaParams?.showPoweredBy || false,
		showFooterOnEvent:                     window.arenaParams?.showFooterOnEvent || false,
		headerSponsorsColored:                 window.arenaParams?.headerSponsorsColored || false,
		arenaInfos:                            window.arenaParams?.arenaInfos || null,
		csrfToken:                             window.arenaParams?.csrfToken || '',
		contactEmail:                          window.arenaParams?.contactEmail || '',
		loadArenaProfile:                      window.arenaParams?.loadArenaProfile || false,
		navItems:                              window.arenaParams?.navItems || null,
		isLightTheme:                          document.body.classList.contains('-t-light'),
		theme:                                 window.arenaParams?.theme || 'asport',
		subTheme:                              window.arenaParams?.subTheme || null,
		themeModifiers:                        window.arenaParams?.themeModifiers || [],
		geoblocking:                           window.arenaParams?.geoblocking || {},
		imprintOverrideMode:                   window.arenaParams?.imprintOverrideMode || null,
		imprintOverrideSections:               window.arenaParams?.imprintOverrideSections || [],
		imprintOverrideExternalLinks:          window.arenaParams?.imprintOverrideExternalLinks || null,
		profileFields:                         window.arenaConfig?.profileFields || {},
		paymentOfferGroups:                    window.arenaConfig?.paymentOfferGroups || null,
		hamburgerPosition:                     window.arenaConfig?.hamburgerPosition || 'default',
		prominentMobileTopNav:                 window.arenaConfig?.prominentMobileTopNav || false,
		autoplay:                              window.arenaConfig?.autoplay ?? true,
		primaryPreRollAdUrl:                   window.arenaConfig?.primaryPreRollAdUrl ?? null,
		enableNativeFullscreenOnIos:           window.arenaConfig?.enableNativeFullscreenOnIos ?? false,
		enableProfileCompletion:               window.arenaConfig?.enableProfileCompletion ?? false,
		ageRestrictedEventIds:                 window.arenaConfig?.ageRestrictedEventIds || [],
		eventCenterNavigationLabel:            window.arenaParams?.eventCenterNavigationLabel || null,
	};
};
